export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const ANONYMOUS_AUTH_SUCCESS = 'ANONYMOUS_AUTH_SUCCESS'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_GET_PROFILE = 'AUTH_GET_PROFILE'
export const AUTH_RECOVER_PASSWORD = 'AUTH_RECOVER_PASSWORD'
export const AUTH_VALIDATE_TOKEN= 'AUTH_VALIDATE_TOKEN'
export const AUTH_RESET_PASSWORD= 'AUTH_RESET_PASSWORD'
export const AUTH_SET_TOKEN_VALID= 'AUTH_SET_TOKEN_VALID'
export const AUTH_GET_ME = 'AUTH_GET_ME'
export const AUTH_GET_CUSTOMER_PROFILE = 'AUTH_GET_CUSTOMER_PROFILE'
export const AUTH_SET_CUSTOMER_PROFILE = 'AUTH_SET_CUSTOMER_PROFILE'
export const ANONYMOUS_AUTH_REQUEST = 'ANONYMOUS_AUTH_REQUEST'
export const AUTH_SET_PORTAUS_COMPANY = 'AUTH_SET_PORTAUS_COMPANY'
export const AUTH_SET_SYS_PROP = 'AUTH_SET_SYS_PROP'
export const SET_ANONYMOUS_AUTH = 'SET_ANONYMOUS_AUTH'
